<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Customers</translate></template>
            <template v-slot:buttons>
                <GekkoButton 
                    v-if="!isGekkoAccountant" 
                    @click="inviteCustomer()" 
                    :text="$gettext('Invite Customer')" 
                    icon="fa fa-plus" class="mr-2" />
                <GekkoButton 
                    v-if="!isGekkoAccountant"
                    @click="showPendingInvitations()" 
                    :text="$gettext('Pending Invitations')" 
                    icon="fa fa-paper-plane" 
                    type="ghost" />
                <GekkoButton 
                    v-if="isGekkoAccountant"
                    @click="connectGekkoAccountant()"
                    :text="$gettext('Connect Gekko Accountant')"
                    icon="fa fa-gear"
                    class="ml-2"
                    variant="danger" />
            </template>
        </TitleBar>
        <div class="content">
            <InviteCustomerModal ref="invite_customer_modal" />
            <PendingInvitesModal ref="pending_invites_modal" @refreshlist="$refs.customer_list.refreshConnections()" />
            <GekkoAccountantModal @connected="onGekkoAccountantConnected" ref="gekko_accountant_modal" />
            <CustomerList ref="customer_list" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import GekkoButton from "@/components/GekkoButton";
import TitleBar from "@/components/TitleBar";
import CustomerList from "@/components/accountants/CustomerList";
import InviteCustomerModal from "@/components/accountants/InviteCustomerModal.vue";
import PendingInvitesModal from "@/components/accountants/PendingInvitesModal.vue";
import GekkoAccountantModal from "@/components/accountants/GekkoAccountantModal.vue";

export default {
    name: 'Customers',
    components: {GekkoButton, TitleBar, CustomerList, InviteCustomerModal, PendingInvitesModal, GekkoAccountantModal},
    methods: {
        inviteCustomer() {
            this.$refs.invite_customer_modal.showInviteCustomerModal = true;
        },
        showPendingInvitations() {
            this.$refs.pending_invites_modal.showPendingInvitationsModal = true;
        },
        connectGekkoAccountant() {
            this.$refs.gekko_accountant_modal.showGekkoAccountantModal = true;
        },
        onGekkoAccountantConnected(connection) {
            this.$refs.customer_list.addGekkoConnection(connection);
        }
    },
    computed: {
        ...mapGetters({
            currentCompany: 'main/getCurrentCompany'
        }),
        isGekkoAccountant() {
            if (this.currentCompany.accountant_branding)
                return this.currentCompany.accountant_branding.is_gekko_accountant;
            else
                return false;
        }
    }
}
</script>